var HttpCode;
(function(HttpCode) {
    HttpCode[HttpCode["Ok"] = 200] = "Ok";
    HttpCode[HttpCode["Created"] = 201] = "Created";
    HttpCode[HttpCode["Accepted"] = 202] = "Accepted";
    HttpCode[HttpCode["NoContent"] = 204] = "NoContent";
    HttpCode[HttpCode[// 300
    "MovedPermanently"] = 301] = "MovedPermanently";
    HttpCode[HttpCode["Found"] = 302] = "Found";
    HttpCode[HttpCode["SeeOther"] = 303] = "SeeOther";
    HttpCode[HttpCode["NotModified"] = 304] = "NotModified";
    HttpCode[HttpCode["TemporaryRedirect"] = 307] = "TemporaryRedirect";
    HttpCode[HttpCode["PermanentRedirect"] = 308] = "PermanentRedirect";
    HttpCode[HttpCode[// 400
    "BadRequest"] = 400] = "BadRequest";
    HttpCode[HttpCode["Unauthorized"] = 401] = "Unauthorized";
    HttpCode[HttpCode["Forbidden"] = 403] = "Forbidden";
    HttpCode[HttpCode["NotFound"] = 404] = "NotFound";
    HttpCode[HttpCode["MethodNotAllowed"] = 405] = "MethodNotAllowed";
    HttpCode[HttpCode["NotAcceptable"] = 406] = "NotAcceptable";
    HttpCode[HttpCode["ProxyAuthenticationRequired"] = 407] = "ProxyAuthenticationRequired";
    HttpCode[HttpCode["RequestTimeout"] = 408] = "RequestTimeout";
    HttpCode[HttpCode["Conflict"] = 409] = "Conflict";
    HttpCode[HttpCode["Gone"] = 410] = "Gone";
    HttpCode[HttpCode["LengthRequired"] = 411] = "LengthRequired";
    HttpCode[HttpCode["PreconditionFailed"] = 412] = "PreconditionFailed";
    HttpCode[HttpCode["PayloadTooLarge"] = 413] = "PayloadTooLarge";
    HttpCode[HttpCode["UriTooLong"] = 414] = "UriTooLong";
    HttpCode[HttpCode["UnsupportedMediaType"] = 415] = "UnsupportedMediaType";
    HttpCode[HttpCode["RangeNotSatisfiable"] = 416] = "RangeNotSatisfiable";
    HttpCode[HttpCode["ExpectationFailed"] = 417] = "ExpectationFailed";
    HttpCode[HttpCode["ImATeapot"] = 418] = "ImATeapot";
    HttpCode[HttpCode["MisdirectedRequest"] = 421] = "MisdirectedRequest";
    HttpCode[HttpCode["UnprocessableEntity"] = 422] = "UnprocessableEntity";
    HttpCode[HttpCode["Locked"] = 423] = "Locked";
    HttpCode[HttpCode["FailedDependency"] = 424] = "FailedDependency";
    HttpCode[HttpCode["UpgradeRequired"] = 426] = "UpgradeRequired";
    HttpCode[HttpCode["PreconditionRequired"] = 428] = "PreconditionRequired";
    HttpCode[HttpCode["TooManyRequests"] = 429] = "TooManyRequests";
    HttpCode[HttpCode["RequestHeaderFieldsTooLarge"] = 431] = "RequestHeaderFieldsTooLarge";
    HttpCode[HttpCode["UnavailableForLegalReasons"] = 451] = "UnavailableForLegalReasons";
    HttpCode[HttpCode[// 500
    "InternalServerError"] = 500] = "InternalServerError";
    HttpCode[HttpCode["NotImplemented"] = 501] = "NotImplemented";
    HttpCode[HttpCode["BadGateway"] = 502] = "BadGateway";
    HttpCode[HttpCode["ServiceUnavailable"] = 503] = "ServiceUnavailable";
    HttpCode[HttpCode["GatewayTimeout"] = 504] = "GatewayTimeout";
    HttpCode[HttpCode["HttpVersionNotSupported"] = 505] = "HttpVersionNotSupported";
    HttpCode[HttpCode["VariantAlsoNegotiates"] = 506] = "VariantAlsoNegotiates";
    HttpCode[HttpCode["InsufficientStorage"] = 507] = "InsufficientStorage";
    HttpCode[HttpCode["LoopDetected"] = 508] = "LoopDetected";
    HttpCode[HttpCode["NotExtended"] = 510] = "NotExtended";
    HttpCode[HttpCode["NetworkAuthenticationRequired"] = 511] = "NetworkAuthenticationRequired";
})(HttpCode || (HttpCode = {}));
var BaseHttpCode;
(function(BaseHttpCode) {
    BaseHttpCode[BaseHttpCode["Ok"] = 200] = "Ok";
    BaseHttpCode[BaseHttpCode["Redirect"] = 300] = "Redirect";
    BaseHttpCode[BaseHttpCode["AnyError"] = 400] = "AnyError";
    BaseHttpCode[BaseHttpCode["InputError"] = 400] = "InputError";
    BaseHttpCode[BaseHttpCode["ServerError"] = 500] = "ServerError";
})(BaseHttpCode || (BaseHttpCode = {}));

export { BaseHttpCode, HttpCode };
